<div class="range-slider-wrapper mt-2">
    <!-- Min/Max Input Controls -->
    <div class="slider-controls">
        <sol-text-input #minValue [id]="'minValue'" [label]="minValueLabelText"
            [value]="getDisplayValue(min)" [type]="'text'" [required]="true" [errorState]="!!minError"
            [errorMessageText]="minError" (valueChange)="validateAndSetValue($event, true)">
        </sol-text-input>
        <sol-text-input #maxValue [id]="'maxValue'" [label]="maxValueLabelText"
            [value]="getDisplayValue(max)" [type]="'text'" [required]="true" [errorState]="!!maxError"
            [errorMessageText]="maxError" (valueChange)="validateAndSetValue($event, false)">
        </sol-text-input>
    </div>
</div>
<div class="slider-row">
    <cv-cxone-range-slider #cxoneRangeSlider [min]="min" [max]="max" [metricConversionType]="metricConversionType"
        [startPoints]="startPoints" [metricDirection]="metricDirection" (rangesChanged)="onRangeChange($event)"
        (isRangesOverlap)="onRangesOverlap($event)" [isQualityEvaluationWidget]="isQualityEvaluationWidget">
    </cv-cxone-range-slider>
    <div class="button-group">
        <sol-button class="minus-button" [size]="'small'" [variant]="'basic'"
            [icon]="'../App_Themes/CXone/icons/cxone-minus.svg#cxone-minus'"
            [disabled]="!cxoneRangeSlider || (cxoneRangeSlider.startPoints && cxoneRangeSlider.startPoints.length <= 1)"
            (buttonClick)="removeRangeFromSlider()">
        </sol-button>
        <sol-button class="plus-button" [size]="'small'" [variant]="'basic'"
            [icon]="'../App_Themes/CXone/icons/cxone-plus.svg#cxone-plus'"
            [disabled]="!cxoneRangeSlider || (cxoneRangeSlider.startPoints && cxoneRangeSlider.startPoints.length >= 4)"
            (buttonClick)="addRangeToSlider()">
        </sol-button>
    </div>
</div>